// 护理区
export const nursingAreas = [
    { value: 'TAKE_CARE_SELF', text: '自理区', age: 60 },
    { value: 'SEMI_CARE', text: '半护理区', age: 60 },
    { value: 'FULL_CARE', text: '全护理区', age: 60 },
];
